import { render, staticRenderFns } from "./NewSecurityAction.vue?vue&type=template&id=5c4a31dc&scoped=true&"
import script from "./NewSecurityAction.vue?vue&type=script&lang=ts&"
export * from "./NewSecurityAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a31dc",
  null
  
)

export default component.exports